module.exports = __webpack_public_path__ + "img/e.ea7e75e6.jpg";